<template>
  <div>
    <GlobalHead />
    <div class="globaTitle">
      <div class="top" >
        <div class="title">
          <h1 class="bigWord">{{ title }}</h1>
          <h4 class="smallWord">{{ tag }}</h4>
          <div class="topBtn">
            <span class="btnStyle1" @click="jump()">发起就近办</span>
            <span class="btnStyle1" @click="helpMe('help')">发起视频帮办</span>
          </div>
        </div>
      </div>
    </div>
    <Step ref="step" @initContent="initContent" @initPickType="initPickType"/>
    <div style="margin-bottom: 40px">
      <slot name="content"> </slot>
    </div>
    <!-- <GlobalFoot /> -->
    <!-- 用户须知弹窗 -->
    <UserNotice
      ref="UserNotice"
      :confirm="toVideoPage"
      :config="config"
      :meeting-params="meetingParams"
      :access-token="accessToken"
    />
  </div>
</template>
<script>
import GlobalHead from '@/views/layout/globalHead.vue'
// import GlobalFoot from '@/views/layout/globalFood.vue'
import Step from '@/views/jiopweb/onlineDealWith/components/step.vue'

export default {
  name: 'LocalFeature',
  components: {
    GlobalHead,
    // GlobalFoot,
    Step
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    tag: {
      type: String,
      default: ''
    },
    itemId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      plaintextModel: {},
      model: {},
      config: {},
      meetingParams: {},
      accessToken: ''
    }
  },
  methods: {
    toVideoPage () {
      console.log('确认用户须知')
    },
    getCookieData (cookieName) {
      try {
        var name = cookieName + '='
        var cookieMsg = document.cookie.replace(/%/g, '%25')
        var decodedCookie = decodeURIComponent(cookieMsg)
        var cookieArray = decodedCookie.split(';')
        for (var i = 0; i < cookieArray.length; i++) {
          var cookie = cookieArray[i]
          while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1)
          }
          if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length)
          }
        }
        return ''
      } catch (err) {
        console.log(err, 'cookieErr')
      }
    },
    helpMe (appType) {
      const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
      if (userInfo.isLogin) {
        const params = {
          itemId: this.itemId,
          itemName: this.title,
          applyType: appType
        }
        this.meetingParams = params
        const userParams = JSON.parse(userInfo.desensitizeUser)
        const userType = (this.getCookieData('userType') === 1 || parseInt(userParams.userType) === 1) ? 1 : 2
        this.config = { userType: userType, appType: 1 }
        this.accessToken = this.getCookieData('accessToken')
        const userInfoType = appType === 'help' ? 'yhxz' : 'yhxy'
        this.$refs.UserNotice.showModal(userInfoType)
        this.visibleTip = false
      } else {
        // 是否登录提示框（未登录）
        this.visibleTip = true
      }
    },
    jump () {
      window.open(window.location.origin + '/zwdt/index.html?itemName=' + this.title, '_blank')
      // window.open('https://zwfw.hanweb.com' + '/zwdt/index.html?itemName=' + this.title, '_blank');
    },
    hitMe (val) {
      this.$message.success(val)
    },
    nextStep () {
      this.$refs.step.nextStep()
    },
    previousStep () {
      this.$refs.step.previousStep()
    },
    initContent (str, str2, userAgreement, userAgreeMentName) {
      // console.log(str, str2, userAgreement, userAgreeMentName, 'initContent')
      this.$emit('initContent', str, str2, userAgreement, userAgreeMentName)
    },
    initPickType (pickTypeContent) {
      this.$emit('initPickType', pickTypeContent)
    }
  }

}
</script>
<style lang="less" scoped>
.globaTitle {
  height: 230px;
  // width: 100%;
  background: #325485;
}
.top{
  width: 1200px;
  height: 100%;
  margin: auto;
  background:url(../../../../assets/jiopweb3.0.0/publicBelt2.png) repeat-y;
  display: flex;
}
.topBtn{
  margin-top: 24px;
  .btnStyle1 {
    height: 40px;
    display: inline-block;
    width: 110px;
    color: #fff;
    // background: #1777ff;
    background: rgba(23, 119, 255, 0.8);
    line-height: 40px;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    margin-right: 18px;
  }
}
.title{
  width:1200px;
  margin: auto;
  // padding: 62px 0;
}
.bigWord{
  font-size: 36px;
  color: white;
  width:1200px;
}
.smallWord{
  font-size: 16px;
  color: white;
  width:1200px;
}
</style>
